import { useState } from "react";
import { InsuranceRead } from "../../../../types";

export function useManageInsurance() {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedInsurance, setSelectedInsurance] =
    useState<InsuranceRead | null>(null);

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedInsurance(null);
  };

  const handleRowClick = (rowData: { data: InsuranceRead }) => {
    setSelectedInsurance(rowData.data);
    setIsDetailsModalOpen(true);
  };

  return {
    handleRowClick,
    selectedInsurance,
    isDetailsModalOpen,
    handleCloseDetailsModal,
  };
}
